import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkExperience  {
    _originalTypeClassName = "zERP.BO.WorkExperience";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkExperience.translate = translateService;
}
this.ProjectWorkExperience = [];
this.Id = null;
this.Code = null;
this.Company = null;
this.Position = null;
this.Salary = null;
this.DateFrom = null;
this.DateTo = null;
this.ExperienceYears = null;
this.ExperienceMonths = null;
this.ExperienceDays = null;
this.AcknowledgeSalary = false;
this.AcknowledgeDayOffs = false;
this.AcknowledgeContractTermination = false;
this.NumOfStamps = null;
this.hasActiveContract = false;
this.State = null;
this.HRComment = null;
this.EmpComment = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Company:any;
Position:any;
Salary:any;
DateFrom:any;
DateTo:any;
ExperienceYears:any;
ExperienceMonths:any;
ExperienceDays:any;
AcknowledgeSalary:any;
AcknowledgeDayOffs:any;
AcknowledgeContractTermination:any;
NumOfStamps:any;
hasActiveContract:any;
State:any;
HRComment:any;
EmpComment:any;
Employee:any;
ProjectWorkExperience:any;
ContactDetails:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removePastWorkExpirience(oldValue, $this);
}
Domain.Employee.addPastWorkExpirience(value, $this);
}
}
static setProjectWorkExperience = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectWorkExperience == null) $this.ProjectWorkExperience = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectWorkExperience.length > 0) {
                    Domain.WorkExperience.removeProjectWorkExperience($this, $this.ProjectWorkExperience[0]);
                }

                Domain.WorkExperience.addManyProjectWorkExperience($this, copyItems);
            }
static addManyProjectWorkExperience = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkExperience.addProjectWorkExperience($this, items[i]);
                }
            }
static addProjectWorkExperience = ($this, item) => {
                if ($this.ProjectWorkExperience == null) $this.ProjectWorkExperience = [];
                if (item == null || $this.ProjectWorkExperience.indexOf(item) > -1) return;
                $this.ProjectWorkExperience.push(item);
if (item.WorkExperience != $this) {
Domain.ProjectWorkExperience.setWorkExperience(item, $this);
}
}
static addRangeProjectWorkExperience = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkExperience.addProjectWorkExperience($this, item));
            }
static removeProjectWorkExperience = ($this, item) => {
                if ($this == null || $this.ProjectWorkExperience == null || $this.ProjectWorkExperience.indexOf(item) === -1) return;
                var _index = $this.ProjectWorkExperience.indexOf(item);
                $this.ProjectWorkExperience.splice(_index, 1);
item.WorkExperience = null;
}
static clearProjectWorkExperience = ($this) => { $this.ProjectWorkExperience = null; }
static setContactDetails = ($this, value) => {
var oldValue = $this.ContactDetails;
$this.ContactDetails = value;
if (value != null) {
}
}

static FillAmounts($this: any): any{let from = $this?.DateFrom;
let to = $this?.DateTo;
if (to == null || CLMS.Framework.Number.LessThan(() => moment(to).year(), () => 1920)) {to = moment().toDate();}
if ($this?.DateFrom == null || CLMS.Framework.Number.LessThan(() => moment($this.DateFrom).year(), () => 1920) || (new Date($this?.DateFrom).getTime()) > (new Date(to).getTime())) {return;}
to = (moment(to).add(1, "d")).toDate();
$this.ExperienceDays = 0;
$this.ExperienceMonths = 0;
$this.ExperienceYears = 0;
$this.ExperienceYears = Joove.Common.safeNumber(moment(to).year()) - Joove.Common.safeNumber(moment($this?.DateFrom).year());
$this.ExperienceMonths = Joove.Common.safeNumber((moment(to).month() + 1)) - Joove.Common.safeNumber((moment($this?.DateFrom).month() + 1));
$this.ExperienceDays = Joove.Common.safeNumber(moment(to).date()) - Joove.Common.safeNumber(moment($this?.DateFrom).date());
if ((CLMS.Framework.Number.LessThan(() => $this.ExperienceDays, () => 0))) {$this.ExperienceMonths = Joove.Common.safeNumber($this?.ExperienceMonths) - Joove.Common.safeNumber(1);$this.ExperienceDays = Joove.Common.safeNumber($this?.ExperienceDays) + Joove.Common.safeNumber(moment("moment(to).year()-((CLMS.Framework.Number.Equal(()=>(moment(to).month()+1)-()=>1))?12:Joove.Common.safeNumber((moment(to).month()+1))-Joove.Common.safeNumber(1))", "YYYY-MM").daysInMonth());}
if ((CLMS.Framework.Number.LessThan(() => $this.ExperienceMonths, () => 0))) {$this.ExperienceYears = Joove.Common.safeNumber($this?.ExperienceYears) - Joove.Common.safeNumber(1);$this.ExperienceMonths = Joove.Common.safeNumber($this?.ExperienceMonths) + Joove.Common.safeNumber(12);}
if (CLMS.Framework.Number.Equal(() => $this.ExperienceDays, () => 30)) {$this.ExperienceDays = 0;$this.ExperienceMonths = Joove.Common.safeNumber($this?.ExperienceMonths) + Joove.Common.safeNumber(1);if (CLMS.Framework.Number.Equal(() => $this.ExperienceMonths, () => 12)) {$this.ExperienceMonths = 0;$this.ExperienceYears = Joove.Common.safeNumber($this?.ExperienceYears) + Joove.Common.safeNumber(1);}}
}
static GetClassName(): any{return "WorkExperience";
}
static isAcknowledgeContractTermination(el: any): any{return el == "ΝΑΙ";
}
static isAcknowledgeDayOffs(el: any): any{return el == "ΝΑΙ";
}
static isAcknowledgeSalary(el: any): any{return el == "ΝΑΙ";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}